import Vue from 'vue'
import SvgIcon from '@/SvgIcon/index.vue'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)
debugger
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
